import React from "react";
import { useParams } from "react-router";
import { PaperTabLayout } from "frontend/src/ui/paper-tab-layout";
import { useRawTrackDetail } from "frontend/src/domain/tracks";
import { Form } from "./track";
import { useTrack } from "./track/model";
import { AdminLayout } from "frontend/src/pages/layouts";
import { TabsSkeleton } from "frontend/src/ui/tabs-skeleton";
import { Skeleton } from "@material-ui/lab";
import { Box } from "@material-ui/core";
import { TableSkeleton } from "frontend/src/ui/table-skeleton";
var Page = function (_a) {
    var track = _a.track;
    var _b = useTrack(track), artist = _b.artist, title = _b.title, clientId = _b.clientId, actions = _b.actions;
    var tabs = [
        {
            label: "Трек",
            node: (React.createElement(Form, { title: title, artist: artist, 
                // type={type}
                client: clientId, 
                // published={published}
                handlers: {
                    submit: {
                        do: actions.update.run,
                        pending: actions.update.pending,
                    },
                    play: actions.play,
                    pause: actions.pause,
                } })),
        },
        // {
        //     label: "Каталог",
        //     node: (
        //         <SearchCatalog
        //             addedTrackCounter={addedTracksMap}
        //             onTrackRemove={entries.remove.byIdLast}
        //             onTrackAdd={entries.add}
        //         />
        //     ),
        // },
    ];
    return React.createElement(PaperTabLayout, { tabs: tabs, keepMounted: true });
};
export var EditTrackPage = function () {
    var id = useParams().id;
    var _a = useRawTrackDetail(Number(id)), track = _a.track, remove = _a.remove;
    React.useEffect(function () {
        return remove;
    }, []);
    return (React.createElement(AdminLayout, null, !track ? (React.createElement(TabsSkeleton, null,
        React.createElement(Skeleton, { variant: "rect", height: 200, width: "100%" }),
        React.createElement(Box, { mt: 1 },
            React.createElement(TableSkeleton, { rows: 25, columns: 6 })))) : (React.createElement(Page, { track: track }))));
};
